<template>
  <div class="Matters">
    <van-nav-bar title="调研填报" left-arrow  @click-left="onClickLeft"> </van-nav-bar>
    <div class="matterCon">
      <div class="navslist">
        <div class="navli" style="color: #fff;">基础填报</div>
        <div class="navli" style="color: #fff;">文件上传</div>
        <div class="navli">填报完成</div>
      </div>
      <div class="mmhead">
        <div class="nng">根据你填报的内容需要准备以下证明文件进行上传</div>
        <template v-for="(li,i) in questionUpload.question_data" :key="i">
          <p v-if="li.fileNum!=null&&li.fileNum>0">{{getNum(li)}}.{{li.fileRemarks}}</p>
        </template>
      </div>
      <van-cell-group ontset>
        <template v-for="(li,i) in questionUpload.question_data" :key="i">
          <div class="upgroup" v-if="li.fileNum!=null&&li.fileNum>0">
            <div class="upname" >{{li.fileRemarks}}（最少{{ li.fileNum }}张）</div>
            <van-uploader v-model="li.files"  :after-read="afterRead" upload-icon="plus"/>
          </div>
        </template>
<!--        <template v-for="(li,index) in question.question_data" :key="index">-->
<!--          <van-cell-group >-->

<!--            <div class="hstitle2">（最少{{ li.fileNum }}张）</div>-->
<!--            <van-field name="uploader">-->
<!--              <template #input>-->
<!--                <van-uploader v-model="li.files" :after-read="afterRead" upload-icon="plus"/>-->
<!--              </template>-->
<!--            </van-field>-->
<!--          </van-cell-group>-->
<!--        </template>-->
<!--        <div class="upgroup">-->
<!--          <div class="upname" >上传社保缴纳证明文件</div>-->
<!--          <van-uploader :after-read="afterRead" />-->
<!--        </div>-->
<!--        <div class="upgroup">-->
<!--          <div class="upname" >上传专精特新认证文件</div>-->
<!--          <van-uploader :after-read="afterRead" />-->
<!--        </div>-->
<!--        <div class="upgroup">-->
<!--          <div class="upname" >上传“独角兽”企业认定证书</div>-->
<!--          <van-uploader :after-read="afterRead" />-->
<!--        </div>-->
<!--        <div class="upgroup">-->
<!--          <div class="upname" >上传“瞪羚”企业认定证书</div>-->
<!--          <van-uploader :after-read="afterRead" />-->
<!--        </div>-->
      </van-cell-group>
      <van-sticky :offset-bottom="0" position="bottom">
      <div class="nextbtn" >
        <van-button type="primary" @click="clickNext" block round size="large" color="#2f58e4">下一步</van-button>
      </div>
      </van-sticky>
    </div>

  </div>
</template>

<script>
import {post, baseUrl, cache} from "../api/http"
import {Dialog} from "vant";
import moment from 'moment';
import { ref } from 'vue';
export default {
  name: "MattersCon",
  setup() {

    const result = ref('');
    const showPicker = ref(false);
    const columns = ['装备制造1', '装备制造2', '装备制造3', '装备制造4', '装备制造5'];
    const checked = ref('1');

    return {
      result,
      columns,
      showPicker,
      checked,
    };
  },
  data() {
    return {
      loading: false,
      finished: false,
      refreshing: false,
      num:0,
      question:{
        question_data:[],
      },
      questionUpload:{
        question_data:[],
      },
    }

  },
  mounted() {
    this.num=0
    this.question=cache("question")
    var qd=cache("questionData")
    if(qd==null){
      this.questionUpload=cache("question")
    }
  },
  watch: {
    questionData: {//深度监听，可监听到对象、数组的变化
      handler() {
        cache("questionData",this.questionData)
      },
      deep: true //true 深度监听
    }
  },

  methods: {

    afterRead(file) {
      // 此时可以自行将文件上传至服务器
      post("app/user/upload",{file:file.content}).then(function (res) {
        file.url = res.result
        // file.file=null
        // file.content=null
        // file.message=null
        // file.status==null
      })
    },
    getNum(li){
      if(li.fileNum!=null&&li.fileNum>0&&li.num==null){

        console.log(li)
        this.num++
        li.num=this.num
      }
      return  li.num
    },
    clickNext(){


      for(var i=0;i<this.questionUpload.question_data.length;i++){
        var data=this.questionUpload.question_data[i]
        if(data.fileNum==null||data.fileNum==0){
          continue
        }
        if(data.files==null){
          Dialog({message:"你还没有上传“"+data.fileRemarks+"”项文件内容"})
          return
        }
        if(data.files.length<data.fileNum){
          Dialog({message:"“"+data.fileRemarks+"”项文件内容,上传文件数量不够"})
          return
        }
        this.question.question_data[i].files=[]
        for(var j=0;j<data.files.length;j++){
          this.question.question_data[i].files.push({url:data.files[j].url})
        }
      }
      cache("question",this.question)
      var that=this
      post("app/question/update", {id:this.question.id,status:2,question_data: JSON.stringify(this.question.question_data)}).then(function () {
        that.$router.push({'path': '/matterFinish'})
      })

    },
    getTime(unixTime){

      return moment(unixTime * 1000).format("YYYY-MM-DD HH:mm:ss");
    },

    setImg(src) {
      if (src == null || src == "") {
        return "./img/logo.png"
      }
      return baseUrl + "/" + src
    },
    onClickLeft: function(){
      this.$router.push({'path': '/matterCon'})
    },
  },
}
</script>

<style scoped>
.mmhead{padding: 30px;margin-top: 10px;background: #fff}

.mattertitle h1{font-size: 16px}
.mdate span{font-size: 14px;margin-left: 10px}
.nextbtn{padding: 0 30px 30px;margin: 20px 0}
.navslist {
  height: 40px;background: #fff;
}
.navli{
 text-align: center;
  height: 40px;
  line-height: 40px;
  background: #fff;
  display: inline-block;
  width: 33.3%;
}
.navslist .navli:first-child{
  background: url("../assets/img/poo2.png") no-repeat;background-size: 100% 100%;
  background-color: #2f58e4;
}
.navslist .navli:nth-child(2){
  background: url("../assets/img/po2.png") no-repeat;background-size: 100% 100%;
}
.mmhead p{padding: 3px 0}
.nng{padding-bottom: 5px;font-size: 16px;font-weight: bold}
.upgroup{padding:10px 10px 15px;border-bottom: 1px solid #eee;margin: 0 20px}
.upname{padding: 10px 0px 15px}


</style>

